import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'
import { TypeformResponseVariable } from '@/api/model/typeform/typeform-response-variable'
import { TypeformResponseDefinition } from '@/api/model/typeform/typeform-response-definition'
import { TypeformResponseAnswer } from '@/api/model/typeform/typeform-response-answer'
import { TypeformMap } from '@/api/model/typeform/typeform-map'
import { Agenda, Relatie, WonenObject } from '@/api/realworks-types'

export class TypeformResponse extends BaseModel<TypeformResponse> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public id: string,
        public token: string,
        public submittedAt: Date,
        public landedAt: string,
        public calculatedScore: number|null,
        public variables: TypeformResponseVariable[],
        public hidden: TypeformMap,
        public definition: TypeformResponseDefinition,
        public answers: TypeformResponseAnswer[],
        public agenda: Agenda|null,
        public medewerker: Relatie|null,
        public relatie: Relatie|null,
        public wonenObject: WonenObject|null,
    ) { super(id) }

    toRequestData(): any {
        return {
            id: this.id,
            token: this.token,
            submittedAt: this.submittedAt,
            landedAt: this.landedAt,
            calculatedScore: this.calculatedScore,
            variables: this.variables,
            hidden: this.hidden,
            definition: this.definition,
            answers: this.answers,
            agenda: this.agenda,
            medewerker: this.medewerker,
            relatie: this.relatie,
            wonenObject: this.wonenObject,
        }
    }

    static fromData(data: any): TypeformResponse {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponse) {
            return data
        }

        return new TypeformResponse(
            data.id,
            data.token,
            data.submittedAt,
            data.landedAt,
            data.calculatedScore,
            Object.values(data.variables || {}).map(entry => TypeformResponseVariable.fromData(entry)),
            data.hidden,
            TypeformResponseDefinition.fromData(data.definition),
            Object.values(data.answers || {}).map(entry => TypeformResponseAnswer.fromData(entry)),
            data.agenda || null,
            data.medewerker || null,
            data.relatie || null,
            data.wonenObject || null,
        )
    }
}
